import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, NavigationStart } from '@angular/router'
import { CurrentSlideService } from '../../_services/current-slide.service';
import { SectionsService } from '../../_services/sections.service';

import { Subject } from 'rxjs';
import { takeUntil} from 'rxjs/operators';

@Component({
	selector: 'main-nav',
	templateUrl: './main-nav.component.html',
	styleUrls: ['./main-nav.component.scss'],
	host: {'class': 'main-nav'}
})
export class MainNavComponent implements OnInit {

	private unsubscribe$ = new Subject<void>();
	public sections;
	public activeSectionPosition;
	public itemsPosition;
	public newRoute;
	public isStory = false;
	public isMenuOpen = false;


	constructor(private _router: Router, private _currentSlideService: CurrentSlideService, private _sectionsService: SectionsService) { 
		this.sections = this._sectionsService.getSections();
		this.activeSectionPosition = this._sectionsService.getCurrentSectionPosition();
		this.itemsPosition = this.sections.position;

		_router.events
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe( (event: Event) => {
			if (event instanceof NavigationEnd) {
				let url = this._router.url.split('/');
				if(url[2] == 'story'){
					this.isStory = true;
				}
				else{
					this.isStory = false;
					//this.newRoute = this._router.url.replace('/', '');
					//let section = this.sections.find(data => data.routeName === this.newRoute);
					
					let section = this.sections.find(data => data.position === this._sectionsService.getCurrentSectionPosition());
					this.setSectionPosition(section.position);
				}
			}
		});
	}

	ngOnInit() {
		this._sectionsService.changeSection
		.pipe(takeUntil(this.unsubscribe$))
		.subscribe(position => {
			let section = this.sections.find(data => data.position === this._sectionsService.getCurrentSectionPosition());
			this.isMenuOpen = false;
			if(!this.isStory){
				this.setSectionPosition(section.position);
			}
			else{
				this._router.navigate(['']);
				this.setSectionPosition(section.position);
			}
		});
	}

	goToSection(sectionId){
		this._sectionsService.setCurrentPosition(sectionId);
	}
	setSectionPosition(position){
		//this._sectionsService.setCurrentPosition(position);
		this.itemsPosition = position;
		this._currentSlideService.setCurrenSlide(0);
	}

	isActiveSection(position){
		if(this.activeSectionPosition == position){
			return 'true';
		}
		else{
			return 'false'
		}
	}

	toggleMenu(){
		this.isMenuOpen = !this.isMenuOpen;
		//console.log(this.isMenuOpen)
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}  

}
